import { ImageOff } from 'lucide-react';
import { cn } from '@/lib/utils';

export const ProductImage = ({ src, alt, className }: { src: string | null; alt: string; className?: string }) =>
  src ? (
    <img src={src} alt={alt} loading="lazy" className={cn('size-full object-cover', className)} />
  ) : (
    <div
      role="img"
      aria-label={`${alt} – fotó hamarosan`}
      className={cn('flex size-full flex-col items-center justify-center gap-2 bg-sand-soft text-ink-soft', className)}
    >
      <ImageOff className="size-10" aria-hidden="true" />
      <span className="text-sm">Fotó hamarosan</span>
    </div>
  );
